/* Native page chrome only. Page content, forms and cart destinations remain native. */
(() => {
  'use strict';
  if (!document.body.classList.contains('ac21-native-chrome')) return;
  const header = document.querySelector('.site-header');
  const footer = document.getElementById('footer');
  if (!header || !footer || header.dataset.ac21ChromeBound === 'true') return;
  header.dataset.ac21ChromeBound = 'true';

  const mobileFooter = matchMedia('(max-width: 767px)');
  function syncFooter() {
    footer.querySelectorAll('.ac-footer-group').forEach(group => {
      group.open = !mobileFooter.matches;
      const summary = group.querySelector('summary');
      if (!summary) return;
      if (mobileFooter.matches) summary.removeAttribute('tabindex');
      else summary.tabIndex = -1;
    });
  }
  document.addEventListener('click', event => {
    const menu = event.target.closest?.('[data-menu]');
    if (menu && header.contains(menu)) {
      event.preventDefault();
      window.ACTICLEAR_NAV?.toggleMobile();
    }
    if (!mobileFooter.matches && event.target.closest?.('#footer .ac-footer-group summary')) {
      event.preventDefault();
    }
  });
  mobileFooter.addEventListener('change', syncFooter);
  syncFooter();

  const cartLink = header.querySelector('.cart-icon');
  const badge = header.querySelector('#cart-count');
  const isCount = value => typeof value === 'number' && Number.isInteger(value) && value >= 0;
  let count = Number(cartLink?.dataset.cartCount);
  function setCount(value) {
    if (!isCount(value) || !cartLink || !badge) return;
    count = value;
    cartLink.dataset.cartCount = String(value);
    badge.textContent = value > 99 ? '99+' : String(value);
    badge.hidden = value === 0;
    cartLink.setAttribute('aria-label', `Shopping bag, ${value} ${value === 1 ? 'item' : 'items'}`);
  }
  setCount(count);
  // Existing Horizon product forms report an added quantity; other cart events report totals.
  document.addEventListener('cart:update', event => {
    const { resource, data = {} } = event.detail || {};
    if (data.didError) return;
    if (isCount(resource?.item_count)) setCount(resource.item_count);
    else if (isCount(data.itemCount)) {
      setCount(data.source === 'product-form-component' ? count + data.itemCount : data.itemCount);
    }
  });
})();
